import { Component, OnDestroy, OnInit } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit,OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  sessionTimerData = {
      sessionSeconds:0,
      sessionMinutes:0,
      sessionHours:0,
      sessionDays:0,
      sessionMonths:0
  }
  timeInterval; 

  constructor(private utils:Utility,private emitterService:EmitterService) { }

  ngOnInit(): void {
   let sessionTimerInfo = localStorage.getItem('sessionTimerInfo');
   if(sessionTimerInfo && JSON.parse(sessionTimerInfo) && Object.keys(JSON.parse(sessionTimerInfo))?.length){
    this.sessionTimerData = JSON.parse(sessionTimerInfo)
   }
   this.startSessionTimer();
  }
  startSessionTimer(){
  this.timeInterval = setInterval(()=>{
     if(!this.utils.isUserLoggedIn()){
      clearInterval(this.timeInterval);
      localStorage.removeItem('sessionTimerInfo')
     }else{
      this.updateTimer();
     }
        
     },1000);
  }
  
  updateTimer(){
    this.sessionTimerData.sessionSeconds += 1;
    if(this.sessionTimerData.sessionSeconds == 60){
      this.sessionTimerData.sessionSeconds = 0;
      this.sessionTimerData.sessionMinutes +=1;
      if(this.sessionTimerData.sessionMinutes == 60){
        this.sessionTimerData.sessionMinutes = 0;
        this.sessionTimerData.sessionHours +=1;
        if(this.sessionTimerData.sessionHours == 24){
          this.sessionTimerData.sessionHours = 0;
          this.sessionTimerData.sessionDays +=1;
          if(this.sessionTimerData.sessionDays == 30){
            this.sessionTimerData.sessionDays = 0;
            this.sessionTimerData.sessionMonths+=1
          }
        }
      }
    }
    localStorage.setItem('sessionTimerInfo',JSON.stringify(this.sessionTimerData))
  }
  formatNumber(n){
    return n > 9 ? "" + n: (n ? "0" + n : '00');
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if(this.timeInterval){
      clearInterval(this.timeInterval);
    }
  }

}
